try {
    //window._ = require('lodash'); //Manipulating arrays
    //window.Popper = require('popper.js').default; //Tooltips
    //window.$ = window.jQuery = require('jquery');
} catch (e) {}

/**
 * Set CSRF token as a header based on the value of the "XSRF" token cookie.
 */
//window.axios = require('axios');
//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('./layout.js'); //Contains events for layout elements
require('./reservations.js'); //Contains logic and functionality for reservation page